import { FamilyAnscNotificationsCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsCivilStatusShared from 'shell/components/shared/ansc-notifications/research-family';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsCivilStatusShared
        items={FamilyAnscNotificationsCancellationsCrumbs()}
        scope={IdAmbito.Cancellazioni}
      />
    </Fragment>
  );
};

ResearchFamilyNotificationsCivilStatusPage.displayName =
  'Research Family Notifications CivilStatusPage component';

export default ResearchFamilyNotificationsCivilStatusPage;
